<template>
    <div>
        <v-container grid-list-lg>
            <v-layout row wrap>
                <v-flex xs12 md12>
                    <div>
                        <div class="headline" v-if="$route.params.id == 0">Neue Tour anlegen</div>
                        <div class="headline" v-else>Tour bearbeiten</div>
                    </div>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <v-card class="mb-4">
                        <v-card-title primary-title class="title">Tourdaten</v-card-title>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs6>
                                    <v-select
                                            :items="tourTemplate"
                                            item-value="id"
                                            item-text="tour"
                                            v-model="tour.tourTemplate"
                                            label="Tourvorlage"
                                    >
                                        <template slot="item" slot-scope="data">
                                            <v-btn depressed fab small color="accent">{{ data.item.tour }}</v-btn>
                                            <template v-for="city of getCityNames(data.item.cities)">
                                                <span class="pr-4" :key="city">{{ city }}</span>
                                            </template>
                                        </template>
                                    </v-select>
                                </v-flex>
                                <v-flex xs6>
                                    <v-btn color="primary" class="mt-4" v-on:click="loadTourTemplate()">Laden</v-btn>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs4>
                                    <v-text-field label="Nummer" v-model="tour.tour"></v-text-field>
                                </v-flex>
                              <v-flex xs4>
                                <v-text-field
                                  v-model="editedItem.name"
                                  label="Name"
                                ></v-text-field>
                              </v-flex>
                                <v-flex xs4>
                                    <v-text-field v-model="tour.maxCapacity" label="Maximale Kapazität"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-select
                                    :items="cities"
                                    item-value="id"
                                    v-model="tour.cities"
                                    label="Orte"
                                    multiple
                                    multi-line
                                    chips
                            >
                                <template slot="item" slot-scope="data">
                                    <span class="pr-4">{{ data.item.city }} - {{ data.item.name}}</span>
                                </template>
                                <template slot="selection" slot-scope="data">
                                    <v-chip>{{ data.item.city }} - {{ data.item.name }}</v-chip>
                                </template>
                            </v-select>
                            <v-date-picker v-model="tour.date" landscape locale="de-de" class="mb-4"></v-date-picker>
                        </v-card-text>
                    </v-card>

                </v-flex>
                <v-flex xs12 md6>

                </v-flex>
                <v-btn v-on:click="save()" color="primary">Speichern</v-btn>
                <v-btn v-on:click="deleteEntry()" color="warning">Löschen</v-btn>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
  name: 'TourEdit',
  props: ['id'],
  data: () => ({
    tour: {
      id: 0,
      date: '',
      tour: 0,
      tourTemplate: 0,
      capacity: 0,
      maxCapacity: 0,
      status: 'success',
      cities: [],
      deleted: false,
      vehicle: 0
    }
  }),
  computed: {
    tourTemplate () {
      let tourSorted = this.$store.state.tourTemplate
      return tourSorted.sort((a, b) => a.tour - b.tour)
    },
    cities () {
      return this.$store.state.cities
    }
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData(this.id)
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
    fetchData (id) {
      if (id > 0) {
        let tour = this.$store.state.tour.find(element => element.id === id)
        if (undefined !== tour) {
          this.tour = tour
        }
      }
    },
    save () {
      this.$store.commit('addTour', this.tour)
      this.$router.push('/tour')
    },
    deleteEntry () {
      // TODO Datensazt ausblenden und loggen

      this.tour.deleted = true
      this.$router.push('/tour')
    },
    loadTourTemplate () {
      let tour = this.$store.state.tourTemplate.find(element => element.id === this.tour.tourTemplate)
      if (undefined !== tour) {
        this.tour = tour
      }
    },
    getCity (id) {
      return this.$store.state.cities.find(element => element.id === id)
    },
    getCityNames (districts) {
      let cities = []
      for (let district of districts) {
        let element = this.getCity(district)
        if (cities.indexOf(element.city) === -1) {
          cities.push(element.city)
        }
      }
      return cities
    }
  }
}
</script>

<style scoped lang="scss">
    @import "../scss/settings";
</style>



// WEBPACK FOOTER //
// src/components/TourEdit.vue